import { Drawer, Flex, Form, Spin } from 'antd';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { ComponentsDispatch, RootState } from '../../store';
import { setterCalendar } from '../../store/slices/calendarSlice';
import { setterDrawer } from '../../store/slices/drawerSlice';
import { ItemTaskType, ZIndexType } from '../../types';
import { CalendarTaskForm } from './calendarTaskForm';
import DrawerPanelLabel from './drawerPanelLabel';

const CalendarDrawerPanel = () => {
    const dispatch = useDispatch<ComponentsDispatch>();
    const [form] = Form.useForm<ItemTaskType>();

    const currentTask = useSelector<RootState, ItemTaskType | null>((state) => state.calendar.currentTask);
    const isDragging = useSelector<RootState, boolean>((state) => state.calendar.isDragging);
    const [firstModal] = useSelector<RootState, ZIndexType[]>((state) => state.drawer.currentZIndex);

    const [content, setContent] = useState<React.ReactNode>();
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (isDragging) {
            return;
        }

        if (!currentTask) {
            setOpen(false);
        } else {
            setOpen(true);
            setTimeout(() => {
                setContent(<CalendarTaskForm form={form} />);
            }, 100);
        }
    }, [currentTask, isDragging]);

    useEffect(() => {
        dispatch(setterDrawer({ currentZIndex: ['task', 'item'] }));
    }, [currentTask]);

    const onClose = () => {
        dispatch(setterCalendar({ currentTask: null }));
        setOpen(false);
    };

    return (
        <Drawer
            title={<DrawerPanelLabel form={form} />}
            onClose={onClose}
            open={open}
            mask={false}
            width={600}
            zIndex={firstModal === 'task' ? 1102 : 1101}
            styles={{
                body: {
                    padding: 0,
                    display: 'flex',
                    height: '100%',
                    width: '100%',
                    flex: 1,
                },
            }}
        >
            {content || (
                <Flex vertical flex={1} style={{ width: '100%', height: '100%' }}>
                    <Spin spinning={!content}>
                        <div style={{ height: 300 }}></div>
                    </Spin>
                </Flex>
            )}
        </Drawer>
    );
};

export default CalendarDrawerPanel;
